import Vue from 'vue'
import { sync } from 'vuex-router-sync'
import FlagIcon from 'vue-flag-icon'
import 'auth0-js'

import App from './App.vue'
import router from './router'
import store from './store'

import './plugins/vuetify'
import './styles.scss'

import dotenv from 'dotenv'
import Vuetify from 'vuetify'
import Luci from '@pm-connect/luci'

import 'vuetify/dist/vuetify.min.css'

sync(store, router)
dotenv.config()
Vue.use(FlagIcon)
Vue.use(Vuetify)
Vue.use(Luci)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
